/**
 * Finery markets management API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Update pair setting request.
 */
export interface UpdatePairSettingRequest {
  id: number;
  /**
   * use levels
   * @deprecated
   */
  workSize?: number;
  lvl1: number;
  lvl2: number;
  lvl3: number;
  /**
   * In USD
   */
  maxLoss: number;
  /**
   * Reset loss or not
   */
  resetLoss: boolean;
}
